<script setup lang="ts">
import type { ChartData, ChartOptions } from 'chart.js'
import type { PropType } from 'vue'
import { Line } from 'vue-chartjs'
import merge from 'lodash/merge'
import cloneDeep from 'lodash/cloneDeep'

type LineOptions = ChartOptions<'line'>

const props = defineProps({
  defaultOptions: {
    type: Object as PropType<LineOptions>,
    required: true,
  },
  visualizerOptions: {
    type: Object,
    required: true,
  },
  chartClasses: {
    type: String,
    required: true,
  },
  legendClasses: {
    type: String,
    default: '',
  },
  data: {
    type: Object as PropType<ChartData<'line'>>,
    required: true,
  },
})

const emit = defineEmits(['chartRef'])

const chartRef = ref()
const options = merge(cloneDeep(props.defaultOptions), {} as LineOptions)

const onClickLegendItem = useOnClickLegendItem(chartRef)
</script>

<template>
  <div>
    <div class="relative">
      <Line
        ref="chartRef"
        :class="chartClasses"
        :data="data"
        :options="options"
        @vue:mounted="emit('chartRef', chartRef)"
      />
    </div>
    <ChartLegend
      v-if="props.visualizerOptions.legend.position !== 'none'"
      :class="legendClasses"
      :datasets="data.datasets"
      @click-legend-item="onClickLegendItem"
    />
  </div>
</template>
